import React from "react";
import { useTranslation } from "react-i18next";
import Input from "../../../../../components/Input";
import Dropdown from "../../../../../components/Dropdown";
import { VALIDATION_FIELD_MAPPING } from "../../../../../utils/appConstant";
import { Validation } from "../../../../../interfaces/common";
import { AddEdit as AddEditInterface } from "../../../../../interfaces/customer.interface";

interface AddressProps {
  countries: any[];
  states: any[];
  allCountries: any[];
  allStates: any[];
  allCities: any[];
  cities: any[];
  formData: AddEditInterface;
  validation: Validation;
  dropdownSearchData: any;
  onDropdownSearchChange: (e: any, name: string) => void;
  onKeyDown: (e: any) => void;
  onInputBlur: (e: any, name: string) => void;
  onInputChange: (e: any, name: string) => void;
  view?: boolean;
}

const Address: React.FC<AddressProps> = ({
  countries,
  states,
  allCountries,
  allStates,
  allCities,
  cities,
  formData,
  validation,
  dropdownSearchData,
  onDropdownSearchChange,
  onKeyDown,
  onInputBlur,
  onInputChange,
  view
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="col-md-6">
        <div className="form-floating form-floating-outline">
          <Input
            type="text"
            id={VALIDATION_FIELD_MAPPING.billingAddress1}
            name={VALIDATION_FIELD_MAPPING.billingAddress1}
            error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingAddress1)}
            errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingAddress1)?.message ?? ''}
            label={t("customers.addEdit.pageTexts.form.billingAddress1.label")}
            placeholder={t("customers.addEdit.pageTexts.form.billingAddress1.placeholder")}
            value={formData.billingAddress1}
            onKeyDown={onKeyDown}
            onBlur={e => onInputBlur(e, VALIDATION_FIELD_MAPPING.billingAddress1)}
            onChange={e => onInputChange(e, VALIDATION_FIELD_MAPPING.billingAddress1)}
            disabled={!!view}
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-floating form-floating-outline">
          <Input
            type="text"
            id={VALIDATION_FIELD_MAPPING.billingAddress2}
            name={VALIDATION_FIELD_MAPPING.billingAddress2}
            error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingAddress2)}
            errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingAddress2)?.message ?? ''}
            label={t("customers.addEdit.pageTexts.form.billingAddress2.label")}
            placeholder={t("customers.addEdit.pageTexts.form.billingAddress2.placeholder")}
            value={formData.billingAddress2}
            onKeyDown={onKeyDown}
            onBlur={e => onInputBlur(e, VALIDATION_FIELD_MAPPING.billingAddress2)}
            onChange={e => onInputChange(e, VALIDATION_FIELD_MAPPING.billingAddress2)}
            disabled={!!view}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-floating form-floating-outline">
          <Dropdown
            values={formData.billingCountry ? [formData.billingCountry] : []}
            options={(countries || []).map(country => ({
              label: country.name,
              value: country.id
            }))}
            allOptions={(allCountries || []).map(country => ({
              label: country.name,
              value: country.id
            }))}
            id={VALIDATION_FIELD_MAPPING.billingCountry}
            name={VALIDATION_FIELD_MAPPING.billingCountry}
            searchText={dropdownSearchData.billingCountry}
            onSearch={onDropdownSearchChange}
            placeholder={t("customers.addEdit.pageTexts.form.billingCountry.placeholder")}
            label={t("customers.addEdit.pageTexts.form.billingCountry.label")}
            onChange={onInputChange}
            onBlur={onInputBlur}
            disabled={!!view}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-floating form-floating-outline">
          <Dropdown
            values={formData.billingState ? [formData.billingState] : []}
            options={(states || []).map(state => ({
              label: state.name,
              value: state.id
            }))}
            allOptions={(allStates || []).map(state => ({
              label: state.name,
              value: state.id
            }))}
            id={VALIDATION_FIELD_MAPPING.billingState}
            name={VALIDATION_FIELD_MAPPING.billingState}
            searchText={dropdownSearchData.billingState}
            onSearch={onDropdownSearchChange}
            placeholder={t("customers.addEdit.pageTexts.form.billingState.placeholder")}
            label={t("customers.addEdit.pageTexts.form.billingState.label")}
            onChange={onInputChange}
            onBlur={onInputBlur}
            disabled={!!view}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-floating form-floating-outline">
          <Dropdown
            values={formData.billingCity ? [formData.billingCity] : []}
            options={(cities || []).map(city => ({
              label: city.name,
              value: city.id
            }))}
            allOptions={(allCities || []).map(city => ({
              label: city.name,
              value: city.id
            }))}
            id={VALIDATION_FIELD_MAPPING.billingCity}
            name={VALIDATION_FIELD_MAPPING.billingCity}
            searchText={dropdownSearchData.billingCity}
            onSearch={onDropdownSearchChange}
            label={t("customers.addEdit.pageTexts.form.billingCity.label")}
            placeholder={t("customers.addEdit.pageTexts.form.billingCity.placeholder")}
            onChange={onInputChange}
            onBlur={onInputBlur}
            disabled={!!view}
          />
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-floating form-floating-outline">
          <Input
            type="text"
            id={VALIDATION_FIELD_MAPPING.billingPostal}
            name={VALIDATION_FIELD_MAPPING.billingPostal}
            error={!!validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingPostal)}
            errorMessage={validation.fields.find((field) => field.field === VALIDATION_FIELD_MAPPING.billingPostal)?.message ?? ''}
            label={t("customers.addEdit.pageTexts.form.billingPostal.label")}
            placeholder={t("customers.addEdit.pageTexts.form.billingPostal.placeholder")}
            value={formData.billingPostal}
            onKeyDown={onKeyDown}
            onBlur={e => onInputBlur(e, VALIDATION_FIELD_MAPPING.billingPostal)}
            onChange={e => onInputChange(e, VALIDATION_FIELD_MAPPING.billingPostal)}
            disabled={!!view}
          />
        </div>
      </div>
    </>
  );
};

export default Address;

